import api from "~/services/apis/antecipeApi";

// Janelas (b) e (c) da empresa: `body` = { refusal?, sla? }; sem `body` o PUT vai sem corpo, como antes.
export const sendToAntecipe = async (requestId, body) => {
  return await api.put(`medicalcompany/advancepayment/${requestId}/complete`, body);
};

export const listCompanyPackages = async (params, { signal } = {}) => {
  const response = await api.get("medicalcompany/doctorrequets", { params, signal });
  return { total: Number(response.data.total_items) || 0, rows: response.data.data };
};
